<template>
  <GcBaseLayout
    :title="title"
    :isXSmall="isXSmall"
    :isLarge="isLarge"
    :baseView="baseView"
    :key="pageKey"
    :backButtonEnable="true"
    :backButtonFunction="backButtonFunction"
    :formsConfig="formsConfig"
    :tabs="getTabs"
    :selectedIndex="selectedIndex"
    ref="gc-base-layout"
    class="touch-sales-order-layout"
  >
    <slot> </slot>
    <template #headerContent>
      <GcHeaderContentDynamic
        title="Product"
        :baseView="baseView"
        :createModeIsEditMode="true"
        :primaryLabel="model.ProductCode"
        :secondaryLabel="model.Description1"
        recordType="Product"
        v-if="model.ProductCode"
      />
    </template>
    <div class="css-v2 transaction-screen" v-if="loaded">
      <div class="gc-header-toolbar">
        <gc-form-header-toolbar
          :toolbar-options="getHeaderToolbar"
          :data-model="model"
          :itemSaveCallBack="itemSaveCallBack"
          :backRoute="undefined"
          :setLoading="showLoading"
          ref="gc-form-header-toolbar"
          :baseView="baseView"
        ></gc-form-header-toolbar>
      </div>

      <div class="product-kit-components" v-if="contentHeight">
        <GcProductKits
          :contentHeight="contentHeight"
          :data-model="model"
          :ref="'gc-product-kits'"
        />
      </div>
    </div>
  </GcBaseLayout>
</template>

<script>
import BaseViewMixin from "../../v1/_mixins/base.view";
import { ProductKitComponentsService } from "../../_services/api/products/product-kit-components.service";
import { ProductTabs } from "../../_models/tabdata/products/products-tabs";

export default {
  mixins: [BaseViewMixin],
  created() {
    this.selectedIndex = 6;
    this.initialized();
  },
  data() {
    return {
      model: {
        ProductCode: "",
        Description1: "",
        IsKit: undefined,
        DateChanged: undefined,
        CreatedBy: undefined,
        ChangedBy: undefined,
        DateCreated: undefined,
      },
      loaded: false,
      contentHeight: undefined,
      productKitDetails: undefined,
    };
  },
  computed: {
    getTabs() {
      return ProductTabs(this.baseView.id);
    },
    getHeaderToolbar() {
      return {
        audit: this.baseView.mode == "review",
        status: false,
        notes: false,
        save: true,
        editURL: "/product-kit-components",
        // editCallBack: this.editSOCallBack,
        saveKey: false,
        saveCallback: () => {
          // console.log("Save CallBack");
        },
        screenName: "Kit Components",

        toolbarFormItems: [
          {
            dataField: "ProductCode",
            width: 500,
            label: { text: "Code", visible: false },
            disabled: true,
            editorOptions: {
              allowUpdate: false,
            },
          },
        ],
        auditItems: [
          {
            itemType: "group",
            caption: "",
            items: [
              {
                dataField: "FormattedDateCreated",
                label: { text: "Created By", location: "left" },
                editorType: "dxTextBox",
                editorOptions: {
                  // // disabled: true,
                },
              },
              {
                dataField: "FormattedDateChanged",
                label: { text: "Changed By", location: "left" },
                editorType: "dxTextBox",
                editorOptions: {
                  // disabled: true,
                },
              },
            ],
          },
        ],
      };
    },
  },
  watch: {},
  methods: {
    async itemSaveCallBack() {
      this.productKitDetails = await this.$refs[
        "gc-product-kits"
      ].getDataModels();

      if (this.productKitDetails == false) return;

      var payload = this.getProductKit();
      this.showLoading(true);
      await ProductKitComponentsService.saveProductKit(payload)
        .then(() => {
          this.$notify("Product Kit Updated Successfully", "success");
          this.showLoading(false);

          this.setIgnoreRouteChangeConfirmation();
          this.$router.push({
            path: `/product-kit-components/review/${this.baseView.id}`,
          });
        })
        .catch((err) => {
          this.displayServerError(err, "Product Kit Update Failed");
          this.showLoading(false);
        });
    },
    getProductKit() {
      if (!this.productKitDetails) return {};
      else {
        return {
          KitCode: this.baseView.id,
          SellPrice: this.productKitDetails.dataModel.KitStdSell,
          KitCost: this.productKitDetails.dataModel.KitStdCost,
          StockTakeMethod: this.productKitDetails.dataModel.StocktakeMethod,
          DateChanged: this.productKitDetails.dataModel.DateChanged,
          ProductKitDetails: this.getProductKitDetails(),
        };
      }
    },
    getProductKitDetails() {
      var lines = [];
      this.productKitDetails.detailModel.forEach((element) => {
        lines.push({
          ComponentCode: element.ProductCode,
          Quantity: element.Quantity,
        });
      });

      return lines;
    },
    backButtonFunction() {
      this.$router.push({
        path: "/product",
      });
    },

    async initialized() {
      await ProductKitComponentsService.getProductByCode(this.baseView.id).then(
        (response) => {
          if (response.data.value.length > 0) {
            this.model.ProductCode = response.data.value[0].Code;
            this.model.Description1 = response.data.value[0].Description1;
            this.model.UnitOfMeasureCode =
              response.data.value[0].UnitOfMeasureCode;
            this.model.IsKit = response.data.value[0].IsKit;

            this.model.DateChanged = response.data.value[0].DateChanged;
            this.model.CreatedBy = response.data.value[0].CreatedBy;
            this.model.ChangedBy = response.data.value[0].ChangedBy;
            this.model.DateCreated = response.data.value[0].DateCreated;
          }
        }
      );
      this.loaded = true;

      setTimeout(() => {
        let contentArea = document.querySelector(".dx-scrollable-content");
        if (contentArea) this.contentHeight = contentArea.clientHeight - 50;
      }, 10);
    },
  },
};
</script>

<style lang="scss">
.product-kit-components {
  .css-v2.gc-popup-form {
    padding-bottom: 12px;
    form {
      padding: 12px;
      background-color: white;
    }
  }

  .details-data-grid {
    padding: unset !important;
  }

  .kit-totals-box {
    padding-left: unset !important;
    padding-right: unset !important;
  }
}
</style>
